"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSiteSelectorDispatch = useSiteSelectorDispatch;
exports.useSiteSelector = useSiteSelector;
exports.SiteSelectorContext = exports.SiteSelectorDispatchContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var SiteSelectorDispatchContext = _react["default"].createContext({});

exports.SiteSelectorDispatchContext = SiteSelectorDispatchContext;

var SiteSelectorContext = _react["default"].createContext({
  sites: undefined,
  siteId: undefined
});

exports.SiteSelectorContext = SiteSelectorContext;

function useSiteSelectorDispatch() {
  var context = (0, _react.useContext)(SiteSelectorDispatchContext);

  if (context === undefined) {
    throw new Error('useSiteSelectorDispatch must be used within a SiteSelectorDispatchContext');
  }

  return context;
}

function useSiteSelector() {
  var context = (0, _react.useContext)(SiteSelectorContext);

  if (context === undefined) {
    throw new Error('useSiteSelector must be used within a SiteSelectorContextProvider');
  }

  return context;
}